$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  $('.searchBoxInput input').val('');
  $('#mobileSearchInput').removeAttr('placeholder');
  $('.headerInnerContent .header-inner a.header-logo').clone().prependTo('.mobile-menu-container .mobile-menu-header');
});

$(window).load(function () {
  // ---

});